import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';
import _ from '@/common/helpers';
import {DataExportModel} from '@/common/models/data-export-model';

export default {
    id: 'data-exports',
    version: 1,
    filterSpec: {
        id: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'dataExports',
                labelBuilder: ({id, name}) => `${_.truncate(id, {limit: 11, dots: false})}-${name}`,
                value: 'id',
            },
        },
        name: {
            type: FILTER_TYPES.text,
        },
        resource: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: [
                    'customers',
                    'transactions',
                    'subscriptions',
                ],
            },
        },
        recordCount: {
            type: FILTER_TYPES.numeric,
        },
        '/user/email': {
            label: 'Created By',
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'users',
                labelBuilder: ({firstName, lastName, email}) => `${firstName} ${lastName} (${email})`,
                value: 'email',
            },
        },
        scheduledTime: {
            type: FILTER_TYPES.datetime,
        },
        status: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: Object.values(DataExportModel.Statuses),
            },
        },
    },
};
